/**
 * The printed order's words.
 *
 * ⚠️ `web/` IS ENGLISH-ONLY BY DECISION — `check:i18n` scans `pwa/src` and nothing else, and
 * the officer app is where PA_REQUIREMENTS §7 puts the Bengali requirement. Keeping the
 * strings in one object anyway is this repository's page convention, and it is what makes a
 * printed order's vocabulary reviewable in one screenful rather than scattered through JSX.
 */
export const PRINT = {
  masthead: 'Kolkata Police — Police Arrangement',
  reference: 'Order no.',
  /* ⚠️ [C2b §8b] The department's own number, beside the minted one rather than instead of it. */
  paNumber: 'PA order no.',
  /** ⚠️ [C2b §4f] Reads as a sentence fragment beside the number it names. */
  corrects: 'Corrigendum to',
  orderDate: 'Order date',
  crowd: 'Expected crowd',
  reportTo: 'Report to',
  /* [STAND-DOWN] */
  standDown: 'Stand down',
  /* [C4a §4] */
  zone: 'Zone',
  /* [C5c §4] */
  sector: 'Sector',
  post: 'Post',
  strength: 'Named / asked',
  officers: 'Officers',
  nobodyNamed: 'Not yet named',
  /**
   * ⚠️ [P7A §3] A VEHICLE ROW PRINTS WHAT IT REQUIRES, AND NOTHING ELSE — never `0 / 2`, "Not yet named"
   * or a gap beneath it: a van is counted, never named, and the client's rule is that a vehicle is never
   * shown short. Where a post lists its officers, a vehicle says there is no mapping.
   */
  vehicleRequired: (count: number): string => `${String(count)} required`,
  vehicleNoMapping: 'No vehicle mapping yet',
  /** [C4a §3e] A duty whose every post asks for nobody — never an empty table. */
  noForce: 'No force is asked for on this duty.',
  /**
   * ⚠️ [C5c §2] A COLUMN ASKED FOR ONCE ACROSS THE ORDER, WORDED TO READ ON PAPER — no colour, no
   * icon, and the anchor named twice (its number and its title) because a sheet is read without
   * the screen that would let somebody look it up.
   */
  sharedFrom: (label: string, ordinal: number, title: string): string =>
    `Shared: ${label} — named under DP${String(ordinal)} (${title})`,
  coversEvery: '(covers every duty point)',
  nextDay: '(next day)',
  pointInstructions: 'Instructions for this duty point',
  orderInstructions: 'Instructions for this order',
  supporting: 'Supporting arrangements',
  generated: 'Printed on',
  print: 'Print',
  loading: 'Loading the order…',
  failed: 'This order could not be loaded.',
} as const;
